import { useEffect, useRef, useState } from 'react';

export const usePollingCountdown = (intervalMs: number, onTickEnd: () => void) => {
	const [secondsLeft, setSecondsLeft] = useState(intervalMs / 1000);

	const savedCallback = useRef(onTickEnd);
	useEffect(() => {
		savedCallback.current = onTickEnd;
	}, [onTickEnd]);

	useEffect(() => {
		setSecondsLeft(intervalMs / 1000);

		const timer = setInterval(() => {
			setSecondsLeft((prev) => {
				if (prev <= 1) {
					savedCallback.current();
					return intervalMs / 1000;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(timer);
	}, [intervalMs]);

	const resetCountdown = () => setSecondsLeft(intervalMs / 1000);

	return { secondsLeft: Math.round(secondsLeft), resetCountdown };
};
